import { defineStore } from "pinia";
import { ref, shallowRef, markRaw } from "vue";

export const useModalStore = defineStore("modal", () => {
  const isOpen      = ref(false);
  const component   = shallowRef<any>(null);
  const props       = ref<Record<string, any>>({});
  const onClose     = ref<(() => void) | null>(null);

  function open(comp: any, compProps: Record<string, any> = {}, closeCb?: () => void) {
    component.value = markRaw(comp);
    props.value     = compProps;
    onClose.value   = closeCb ?? null;
    isOpen.value    = true;
  }

  function close() {
    isOpen.value    = false;
    onClose.value?.();
    setTimeout(() => { component.value = null; props.value = {}; }, 300);
  }

  return { isOpen, component, props, open, close };
});
